<div class="cardform">
  <mat-card>
    <mat-card-content>
      <form [formGroup]="eventForm">
        <div class="step-content">
          <p>Selecione o evento:</p>
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Evento</mat-label>
            <mat-select formControlName="event" (selectionChange)="onEventSelected($event.value)">
              <mat-option *ngFor="let ev of events" [value]="ev">{{ev.name}}</mat-option>
            </mat-select>
          </mat-form-field>
          <div *ngIf="isLoadingEvents" class="alert-info">Carregando eventos...</div>
          <div class="actions">
            <button mat-raised-button color="primary" class="custom-button" [disabled]="eventForm.invalid"
              (click)="submit()">Próximo</button>
          </div>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>
